const TripLogSessionArchive = (function ($) {
	return class {
		constructor($el, Swiper) {
			this.Swiper = Swiper;
			this.classPrefix = 'archive-trip-log-session';
			this.photos = [];
			this.currentGalleryIndex = -1;
			this.photoFeedSwiper = null;
			this.gallerySwiper = null;

			// create element references
			this.$el = $el;
			this.sessionId = parseInt($el.attr('data-session-id') || '0', 10);

			this.$photoCarouselContainer = this.$el.find(
				`.${this.classPrefix}__carousel-container`
			);
			this.$galleryContainer = this.$el.find(`.${this.classPrefix}__gallery-container`);
			this.$galleryClose = this.$el.find(`.${this.classPrefix}__gallery-close`);
			this.$galleryCarouselContainer = this.$el.find(
				`.${this.classPrefix}__gallery-carousel-container`
			);
			this.$buttonDownloadPhotos = this.$el.find('.js--download-photo-archive');
			this.$mobileNavContainer = this.$el.find(`.${this.classPrefix}__mobile-nav-container`);
			this.$mobileNavClose = this.$mobileNavContainer.find(
				`.${this.classPrefix}__mobile-nav-close`
			);
			this.$navGroups = this.$el.find(`.${this.classPrefix}__post-nav-group`);
			this.$navItemsDesktop = this.$el.find(
				`.${this.classPrefix}__post-nav-container .${this.classPrefix}__post-nav-item[data-post-id]`
			);
			this.$navItemsMobile = this.$mobileNavContainer.find(
				`.${this.classPrefix}__post-nav-item[data-post-id]`
			);
			this.$navItemMobileTrigger = this.$el.find(
				`.${this.classPrefix}__post-nav-item--mobile`
			);
			this.$buttonPrev = this.$el.find('.js--prev-posts');
			this.$buttonNext = this.$el.find('.js--next-posts');
			this.$buttonDayPrev = this.$el.find('.js--prev-day');
			this.$buttonDayNext = this.$el.find('.js--next-day');
			this.$buttonGalleryPrev = this.$el.find('.js--gallery-prev');
			this.$buttonGalleryNext = this.$el.find('.js--gallery-next');
			this.$dayContainerPrev = this.$el.find(
				`.${this.classPrefix}__button-day-container--prev`
			);
			this.$dayContainerNext = this.$el.find(
				`.${this.classPrefix}__button-day-container--next`
			);
			this.$contentContainer = this.$el.find(`.${this.classPrefix}__content`);
			this.$contentDate = this.$el.find(`.${this.classPrefix}__content-date`);
			this.$contentTitle = this.$el.find(`.${this.classPrefix}__content-title`);
			this.$contentLocation = this.$el.find(`.${this.classPrefix}__content-location--text`);
			this.$contentBody = this.$el.find(`.${this.classPrefix}__content-body`);
			this.$contentAuthor = this.$el.find(`.${this.classPrefix}__content-author`);

			// add event handlers
			this.$mobileNavClose.on('click', this.closeMobileNav);
			this.$galleryClose.on('click', this.closeGallery);
			this.$buttonDownloadPhotos.on('click', this.downloadPhotos);
			this.$navItemMobileTrigger.on('click', this.openMobileNav);
			this.$navItemsDesktop.on('click', this.handleNavItemDesktopClick);
			this.$navItemsMobile.on('click', this.handleNavItemMobileClick);
			this.$buttonPrev.on('click', this.handlePrevGroupClick);
			this.$buttonNext.on('click', this.handleNextGroupClick);
			this.$buttonDayPrev.on('click', this.handleDayClick);
			this.$buttonDayNext.on('click', this.handleDayClick);
			this.$buttonGalleryPrev.on('click', this.handleGalleryPrevClick);
			this.$buttonGalleryNext.on('click', this.handleGalleryNextClick);
			this.$photoCarouselContainer.on('click', this.handlePhotoCarouselClick);
			this.$galleryCarouselContainer.on('click', this.handleGalleryPhotoCarouselClick);

			// load photo feed
			this.loadPhotoFeedCarousel(this.sessionId);
		}

		loadPhotoFeedCarousel(sessionId) {
			$.get(`/wp-json/aq/v1/trip-log-session-photo-feed/${sessionId}`)
				.done((photos) => {
					this.photos = photos;

					const markup = this.buildPhotoCarouselMarkup(this.photos);

					this.$photoCarouselContainer.append(markup);
					this.$photoCarouselContainer.removeClass('loading');

					this.photoFeedSwiper = this.initPhotoCarousel(this.$photoCarouselContainer);
				})
				.fail(() => {})
				.always(() => {});
		}

		buildPhotoCarouselMarkup(photos, opts = {}) {
			opts = {
				imageButtonJSclass: 'js--view-gallery',
				...opts
			};

			const navColPrev = `
				<div class="columns small-1 archive-trip-log-session__carousel-nav-column archive-trip-log-session__carousel-nav-column--prev">
					<button class="archive-trip-log-session__nav-circle archive-trip-log-session__nav-circle--prev" aria-label="previous photo">
						<svg class="archive-trip-log-session__nav-circle-icon" viewBox="0 0 24 24">
							<polyline fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" points="15 18 9 12 15 6"></polyline>
						</svg>
					</button>
				</div>
			`;

			const navColNext = `
				<div class="columns small-1 archive-trip-log-session__carousel-nav-column archive-trip-log-session__carousel-nav-column--next">
					<button class="archive-trip-log-session__nav-circle archive-trip-log-session__nav-circle--next" aria-label="next photo">
						<svg class="archive-trip-log-session__nav-circle-icon" viewBox="0 0 24 24">
							<polyline fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" points="9 18 15 12 9 6"></polyline>
						</svg>
					</button>
				</div>
			`;

			let markup = `
				${navColPrev}
				<div class="columns small-10 archive-trip-log-session__carousel-column">
					<div class="swiper-container">
						<div class="swiper-wrapper">
							${photos
								.map((photo, index) => {
									const photoId = photo.id || 0;
									const thumbUrl = photo?.sizes[0]?.url ?? '';

									return `
									<div class="swiper-slide" data-photo-index="${index}">
										<button class="archive-trip-log-session__carousel-thumb-container ${
											opts.imageButtonJSclass
										}" data-photo-id="${photoId}" data-photo-index="${index}" aria-label="View photo ${
										index + 1
									}">
											<img data-src="${thumbUrl}" class="swiper-lazy archive-trip-log-session__carousel-thumb">
										</button>
										<div class="swiper-lazy-preloader"></div>
									</div>
								`;
								})
								.join('')}
						</div>
					</div>
				</div>
				${navColNext}
			`;

			return markup;
		}

		initPhotoCarousel($container) {
			if (!this.Swiper) {
				return null;
			}

			const swiperContainer = $container.find('.swiper-container').get(0);

			if (!swiperContainer) {
				return null;
			}

			return new this.Swiper(swiperContainer, {
				slidesPerView: 3,
				slidesPerGroup: 3,
				watchSlidesVisibility: true,
				spaceBetween: 15,
				direction: 'horizontal',
				navigation: {
					prevEl: $container
						.find('.archive-trip-log-session__nav-circle--prev')
						.first()
						.get(0),
					nextEl: $container
						.find('.archive-trip-log-session__nav-circle--next')
						.first()
						.get(0)
				},
				autoHeight: true,
				breakpoints: {
					640: {
						slidesPerView: 4,
						slidesPerGroup: 4,
						spaceBetween: 25
					},
					1024: {
						slidesPerView: 5,
						slidesPerGroup: 5,
						spaceBetween: 35
					}
				},
				preloadImages: false,
				lazy: true
			});
		}

		galleryKeyPressHandler = (e) => {
			switch (e.keyCode) {
				case 39: // Right arrow
					this.handleGalleryNextClick();
					break;

				case 37: // Left arrow
					this.handleGalleryPrevClick();
					break;

				case 27: // Escape
					this.closeGallery();
					break;

				default:
					break;
			}
		};

		openGallery(photoIndex) {
			$('html').addClass('disable-body-scroll');

			$(document).on('keyup', this.galleryKeyPressHandler);
			this.$galleryContainer.addClass('active');

			if (!this.gallerySwiper) {
				const markup = this.buildPhotoCarouselMarkup(this.photos, {
					imageButtonJSclass: 'js--view-image'
				});

				this.$galleryCarouselContainer.append(markup);
				this.gallerySwiper = this.initPhotoCarousel(this.$galleryCarouselContainer);
			}

			this.loadGalleryImage(photoIndex);
		}

		closeGallery = () => {
			$('html').removeClass('disable-body-scroll');

			$(document).off('keyup', this.galleryKeyPressHandler);
			this.$galleryContainer.removeClass('active');
		};

		preloadImage(imageUrl) {
			return new Promise((resolve, reject) => {
				const image = new Image();

				// 'onload' is fired when the image has loaded successfully
				image.onload = () => {
					resolve(imageUrl);
				};

				// catch any errors
				image.onerror = () => {
					reject(imageUrl);
				};

				// set the 'src' attribute to begin loading
				image.src = imageUrl;
			});
		}

		showGalleryLoader(showLoader) {
			if (showLoader) {
				this.$galleryContainer.addClass('loading');
			} else {
				this.$galleryContainer.removeClass('loading');
			}
		}

		async loadGalleryImage(photoIndex) {
			const photo = this.photos[photoIndex] ?? null;
			const $imageContainer = this.$galleryContainer
				.find(`.${this.classPrefix}__gallery-main-image-container`)
				.first();

			if (!$imageContainer.length || !photo) {
				return;
			}

			this.$galleryContainer.find('.swiper-slide').removeClass('active');
			this.$galleryContainer
				.find(`.swiper-slide[data-photo-index="${photoIndex}"]`)
				.addClass('active');

			this.currentGalleryIndex = photoIndex;

			if (this.currentGalleryIndex === 0) {
				this.$buttonGalleryPrev.addClass('disabled');
			} else {
				this.$buttonGalleryPrev.removeClass('disabled');
			}

			if (this.currentGalleryIndex >= this.photos.length - 1) {
				this.$buttonGalleryNext.addClass('disabled');
			} else {
				this.$buttonGalleryNext.removeClass('disabled');
			}

			const maxWidth = $imageContainer.width();
			const maxHeight = $imageContainer.height();

			let idealSize = photo.sizes[photo.sizes.length - 1];

			for (let i = photo.sizes.length - 1; i >= 0; i--) {
				if (photo.sizes[i].width >= maxWidth && photo.sizes[i].height >= maxHeight) {
					idealSize = photo.sizes[i];
				}
			}

			this.showGalleryLoader(true);

			try {
				const loadedImageUrl = await this.preloadImage(idealSize.url);

				$imageContainer
					.find(`.${this.classPrefix}__gallery-current-image`)
					.attr('src', loadedImageUrl);

				if (this.gallerySwiper) {
					this.gallerySwiper.slideTo(photoIndex);
				}
			} catch (err) {
				console.error('Unable to load image', err);
			}

			this.showGalleryLoader(false);
		}

		handleGalleryPrevClick = () => {
			if (this.currentGalleryIndex === 0) {
				return;
			}

			this.loadGalleryImage(this.currentGalleryIndex - 1);
		};

		handleGalleryNextClick = () => {
			if (this.currentGalleryIndex >= this.photos.length - 1) {
				return;
			}

			this.loadGalleryImage(this.currentGalleryIndex + 1);
		};

		downloadPhotos = () => {
			const origBtnText = this.$buttonDownloadPhotos.text();
			const errMsg =
				'An error occurred while downloading the requested session photo archive. Please try again.';

			this.$buttonDownloadPhotos.prop('disabled', true);
			this.$buttonDownloadPhotos.text('Please wait...');

			$.get(`/wp-json/aq/v1/trip-photo-archive/generate/${this.sessionId}`)
				.done((res) => {
					if (res.file_id) {
						window.location.href = `/wp-json/aq/v1/trip-photo-archive/download/${res.file_id}`;
					} else {
						alert(errMsg);
					}
				})
				.fail(() => {
					alert(errMsg);
				})
				.always(() => {
					this.$buttonDownloadPhotos.prop('disabled', false);
					this.$buttonDownloadPhotos.text(origBtnText);
				});
		};

		openMobileNav = () => {
			$('html').addClass('mobile-nav-trip-logs-open');
			this.$mobileNavContainer.addClass('active');
		};

		closeMobileNav = () => {
			$('html').removeClass('mobile-nav-trip-logs-open');
			this.$mobileNavContainer.removeClass('active');
		};

		getActiveNavGroupIndex() {
			let activeIndex = 0;

			this.$navGroups.each((index, el) => {
				if ($(el).hasClass('active')) {
					activeIndex = index;
				}
			});

			return activeIndex;
		}

		loadPost(postId) {
			this.$contentContainer.addClass('loading');

			$.get(`/wp-json/wp/v2/trip-logs/${postId}`)
				.done((post) => {
					this.$contentDate.text(post.formatted_date);
					this.$contentTitle.text(post.title.rendered);
					this.$contentLocation.text(post.location);
					this.$contentBody.html(post.content.rendered);
					this.$contentAuthor.text(`- ${post.author}`);

					const prevPostId = post?.prev_next_days?.prev?.id ?? 0;
					const prevPostTitle = post?.prev_next_days?.prev?.title ?? '';
					const nextPostId = post?.prev_next_days?.next?.id ?? 0;
					const nextPostTitle = post?.prev_next_days?.next?.title ?? '';

					if (prevPostId) {
						this.$dayContainerPrev.removeClass('hide');
					} else {
						this.$dayContainerPrev.addClass('hide');
					}

					this.$buttonDayPrev.attr('data-post-id', prevPostId);
					this.$buttonDayPrev
						.find(`.${this.classPrefix}__content-day-title`)
						.text(prevPostTitle);

					if (nextPostId) {
						this.$dayContainerNext.removeClass('hide');
					} else {
						this.$dayContainerNext.addClass('hide');
					}

					this.$buttonDayNext.attr('data-post-id', nextPostId);
					this.$buttonDayNext
						.find(`.${this.classPrefix}__content-day-title`)
						.text(nextPostTitle);

					this.scrollToContent();
				})
				.fail(() => {
					this.$contentDate.text('');
					this.$contentTitle.text('');
					this.$contentLocation.text('');
					this.$contentBody.html('An error occurred while loading the content');
					this.$contentAuthor.text('');

					this.$dayContainerPrev.addClass('hide');
					this.$dayContainerNext.addClass('hide');
				})
				.always(() => {
					this.$contentContainer.removeClass('loading');
				});
		}

		scrollToContent() {
			const $header = $('.site-header');
			let offset = 50;

			if ($header.length) {
				offset += $header.height();
			}

			$([document.documentElement, document.body]).animate(
				{
					scrollTop: this.$contentContainer.offset().top - offset
				},
				500
			);
		}

		handleNavItemDesktopClick = (e) => {
			const $navItem = $(e.currentTarget);
			const postId = parseInt($navItem.attr('data-post-id') || '0');

			this.changeNavItem(postId);
			this.loadPost(postId);
		};

		handleNavItemMobileClick = (e) => {
			const $navItem = $(e.currentTarget);
			const postId = parseInt($navItem.attr('data-post-id') || '0');

			const postDay = parseInt($navItem.attr('data-day-num') || '0', 10);
			const postTitle = $navItem.attr('data-title') || '';
			const postAuthor = $navItem.attr('data-author') || '';

			this.$navItemMobileTrigger
				.find(`.${this.classPrefix}__post-nav-item-day-num`)
				.text(postDay);
			this.$navItemMobileTrigger
				.find(`.${this.classPrefix}__post-nav-item-title-text`)
				.text(postTitle);
			this.$navItemMobileTrigger
				.find(`.${this.classPrefix}__post-nav-item-title-by-value`)
				.text(postAuthor);

			this.changeNavItem(postId);
			this.closeMobileNav();
			this.loadPost(postId);
		};

		handlePrevGroupClick = () => {
			const activeNavGroupIndex = this.getActiveNavGroupIndex();

			if (activeNavGroupIndex <= 0) {
				return;
			}

			this.changeNavGroup(activeNavGroupIndex - 1);
			this.scrollToContent();
		};

		handleNextGroupClick = () => {
			const activeNavGroupIndex = this.getActiveNavGroupIndex();

			if (activeNavGroupIndex >= this.$navGroups.length - 1) {
				return;
			}

			this.changeNavGroup(activeNavGroupIndex + 1);
			this.scrollToContent();
		};

		handleDayClick = (e) => {
			const $button = $(e.currentTarget);
			const postId = $button.attr('data-post-id');

			this.changeNavItem(postId);
			this.loadPost(postId);
		};

		handlePhotoCarouselClick = (e) => {
			const $target = $(e.target);
			let $imageButton = null;

			if ($target.hasClass('.js--view-gallery')) {
				$imageButton = $target;
			} else {
				const $parent = $target.parents('.js--view-gallery').first();

				if ($parent.length) {
					$imageButton = $parent;
				}
			}

			if ($imageButton) {
				const photoIndex = parseInt($imageButton.attr('data-photo-index') || '0', 10);

				this.openGallery(photoIndex);
			}
		};

		handleGalleryPhotoCarouselClick = (e) => {
			const $target = $(e.target);
			let $imageButton = null;

			if ($target.hasClass('.js--view-image')) {
				$imageButton = $target;
			} else {
				const $parent = $target.parents('.js--view-image').first();

				if ($parent.length) {
					$imageButton = $parent;
				}
			}

			if ($imageButton) {
				const photoIndex = parseInt($imageButton.attr('data-photo-index') || '0', 10);

				this.loadGalleryImage(photoIndex);
			}
		};

		getPostData(postId) {
			const postData = {
				id: postId,
				title: '',
				day: '',
				author: ''
			};

			const $navButton = this.$el.find(
				`.${this.classPrefix}__post-nav-item[data-post-id="${postId}"]`
			);

			if (!$navButton.length) {
				return postData;
			}

			postData.title = $navButton.attr('data-title') || '';
			postData.day = parseInt($navButton.attr('data-day-num') || '', 10);
			postData.author = $navButton.attr('data-author') || '';

			return postData;
		}

		updateMobileNavItemText(postId) {
			const postData = this.getPostData(postId);

			this.$navItemMobileTrigger
				.find(`.${this.classPrefix}__post-nav-item-day-num`)
				.text(postData.day);
			this.$navItemMobileTrigger
				.find(`.${this.classPrefix}__post-nav-item-title-text`)
				.text(postData.title);
			this.$navItemMobileTrigger
				.find(`.${this.classPrefix}__post-nav-item-title-by`)
				.text(postData.author);
		}

		changeNavItem(postId) {
			const $targetNavItem = this.$el.find(
				`.${this.classPrefix}__post-nav-item[data-post-id="${postId}"]`
			);

			if ($targetNavItem.length) {
				this.$navItemsDesktop.removeClass('active');
				this.$navItemsMobile.removeClass('active');
				$targetNavItem.addClass('active');

				const $targetNavGroup = $targetNavItem
					.parents(`.${this.classPrefix}__post-nav-group`)
					.first();

				if ($targetNavGroup.length) {
					const targetNavGroupIndex = parseInt(
						$targetNavGroup.attr('data-posts-group-num'),
						10
					);

					this.changeNavGroup(targetNavGroupIndex);
				}

				this.updateMobileNavItemText(postId);
			}
		}

		changeNavGroup(newIndex) {
			if (newIndex === this.getActiveNavGroupIndex()) {
				return;
			}

			this.$navGroups.removeClass('active');
			this.$el.find(`[data-posts-group-num="${newIndex}"]`).addClass('active');

			const disablePrev = newIndex <= 0;
			const disableNext = newIndex >= this.$navGroups.length - 1;

			this.$buttonPrev.prop('disabled', disablePrev);
			this.$buttonNext.prop('disabled', disableNext);
		}
	};
})(jQuery);

export default TripLogSessionArchive;
